import { all, put, takeLatest } from 'redux-saga/effects';

import { SCIApi } from 'src/apis';
import { setFlowAsCompleted } from 'src/components/shared/SciPage/SciPage.duck';
import { QueryClientAccessor } from 'src/redux/QueryClientReduxCompatible';
import { useBookingSummaryKey } from 'src/hooks/useBookingSummary';

import * as api from '../registerCompletion/registerCompletion.api';
import { registerCompletionAction } from './registerCompletion.duck';

function* completeSelfCheckIn() {
    try {
        yield put(setFlowAsCompleted());
        const apiCalls = SCIApi.getInstance();

        yield apiCalls.post(api.completeSelfCheckIn);

        yield put(registerCompletionAction.success({}));

        QueryClientAccessor.getInstance()?.refetchQueries({
            queryKey: [useBookingSummaryKey],
        });
    } catch (error) {
        yield put(registerCompletionAction.failure(error));
    }
}

function* registerCompletionSaga() {
    yield all([takeLatest(registerCompletionAction, completeSelfCheckIn)]);
}

export default registerCompletionSaga;
